import { render, staticRenderFns } from "./linkContact.vue?vue&type=template&id=2418cad3&"
import script from "./linkContact.vue?vue&type=script&lang=js&"
export * from "./linkContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports